import { useSearchParams } from 'react-router'

import { DashboardHeader } from '@/containers/dashboard/DashboardHeader'
import { PpzAuthorizationCreateForm } from '@/containers/ppz-authorization/PpzAuthorizationCreateForm'
import { PpzAuthorizationUserInfo } from '@/containers/ppz-authorization/PpzAuthorizationUserInfo'
import { useAuth } from '@/context/AuthContext'
import { PageWrapper } from '@/layouts/components/PageWrapper'

export const PpzAuthorizationCreatePage = () => {
  const [searchParams] = useSearchParams()
  const { user } = useAuth()

  const userId = searchParams.get('userId') ?? user?.id
  if (!userId)
    throw new Error('User ID is not defined')

  return (
    <PageWrapper
      header={<DashboardHeader title="Nová autorizace PPZ" />}
      mainProps={{
        sx: {
          pt: { base: 0, md: 8 },
          gap: 6,
          display: 'grid',
          w: '100%',
        },
      }}
    >
      <PpzAuthorizationUserInfo userId={userId} />

      <PpzAuthorizationCreateForm userId={userId} />

    </PageWrapper>
  )
}
